
import { DefaultStyle, SamplesStyle, makeStyle } from "./features/map"
import { getRoundedMoneyValue } from "./shared/fieldsHelper";
import Hash from './shared/Hash';


const stylesForSample = [
    makeStyle("#D1001588", "#D10015"),
    makeStyle("#FFE10088", "#FFE100"),
    makeStyle("#63CC2288", "#63CC22"),
    makeStyle("#FFA07788", "#FFA077"),
    makeStyle("#20AFCC88", "#20AFCC"),
    makeStyle("#FF6A0088", "#FF6A00")
]


export const Config = {

    path: "/product/violationsEGRN/",

    metricModuleId: "ViolationsEGRN",

    texts: {
        appName: "Здания и помещения не на кадастре",
        title: ['', ''],
        subtitle: [],
        textInfos: [
            {
                upper: '',
                title: 'Что это?',
                text: [
                    'Текст о том что это такое.',
                ]
            },
            {
                upper: '',
                title: 'Как работает?',
                text: [
                    'Текст о том как это работает.'
                ]
            },
            {
                upper: '',
                title: 'Как использовать?',
                text: [
                    '1. Первый пункт как это использовать.',
                    '2. Второй пункт как это использовать.',
                    '3. Третий пункт как это использовать.'
                ]
            }
        ],
        footer: {
            text: [
                "Всего по России очень много нарушений",
                "на много млрд рублей в год"
            ]
        },
        report: {
            button: "Отчет",
            header: "Получить отчет по территории",
            hint: "Оставьте свои контакты, мы свяжемся с вами",
            thanks: "Спасибо, мы с вами свяжемся в ближайшее время!",
            noRegionStub: "или обсудить любые другие вопросы",
            placeholder: "Почта или телефон",
            whereFromPlaceholder: "Откуда вы",
            request: "Запросить отчет"
        },
        drawing: {
            default: 'Проверить вашу территорию',
            start: 'Указать территорию',
            stop: 'Прекратить рисование'
        }
    },

    layers: [
        {
            id: "settlements",
            label: "Поселения",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_229/{z}/{x}/{y}.pbf",
            maxZoom: 12,
            style: (p) => {
                return p.properties_.level === 3 ? DefaultStyle : undefined;
            },
            turned: false
        },
        {
            id: "municipalitets",
            label: "Муниципалитеты",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_229/{z}/{x}/{y}.pbf",
            maxZoom: 12,
            style: (p) => {
                return p.properties_.level === 2 ? DefaultStyle : undefined;
            },
            turned: false
        },
        {
            id: "regions",
            label: "Регионы",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_229/{z}/{x}/{y}.pbf",
            maxZoom: 12,
            style: (p) => {
                return p.properties_.level === 1 ? DefaultStyle : undefined;
            },
            turned: true
        },
        {
            id: "samples",
            label: "Образец настоящих данных",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_230/{z}/{x}/{y}.pbf",
            maxZoom: 17,
            style: (p) => {
                if (p.properties_.origin === 'egrn_violations_type1') {
                    return stylesForSample[0];
                } else
                    if (p.properties_.origin === 'egrn_violations_type2') {
                        return stylesForSample[1];
                    } else
                        if (p.properties_.origin === 'egrn_violations_type3') {
                            return stylesForSample[2];
                        } else
                            if (p.properties_.origin === 'egrn_violations_type4') {
                                return stylesForSample[3];
                            } else
                                if (p.properties_.origin === 'egrn_violations_type5') {
                                    return stylesForSample[4];
                                } else
                                    if (p.properties_.origin === 'egrn_violations_type6') {
                                        return stylesForSample[5];
                                    }
            },
            turned: false,
            afterTurned: (view) => {
                //view.setCenter([6135702.16836477, 6759726.488507118]) //Оренбург
                view.setCenter([5587958, 7016790]); //Самара
                // view.setCenter([5481772, 7518731]); //Казань
                view.setZoom(12.7);
            }
        }
    ],
    featureInfo: {
        properties: [
            { name: 'Количество нарушений', field: "totalCount", unit: "шт" },
            {
                name: 'Общий налог',
                field: (p) => getRoundedMoneyValue(p, 'totalTax')[0],
                unit: (p) => getRoundedMoneyValue(p, 'totalTax')[1]
            },

            {
                name: 'не учтен в ЕГРН ни как ОКС, ни как совокупность помещений, не связан с ЗУ',
                field: "type1count",
                unit: "шт",
                style: { fontSize: '40px', color: '#D10015' }
            },
            /*{
                name: 'Площадь зданий тип 1',
                field: "type1square",
                unit: "м²",
                style: { fontSize: '40px', color: '#D10015' }
            },*/
            {
                name: 'дополнительный налог',
                field: (p) => getRoundedMoneyValue(p, 'type1tax')[0],
                unit: (p) => getRoundedMoneyValue(p, 'type1tax')[1],
                style: { fontSize: '40px', color: '#D10015' }
            },

            {
                name: 'учтен в ЕГРН как ОКС с неправдоподобно низкой площадью',
                field: "type2count",
                unit: "шт",
                style: { fontSize: '40px', color: '#FFE100' }
            },
            {
                name: 'дополнительный налог',
                field: (p) => getRoundedMoneyValue(p, 'type2tax')[0],
                unit: (p) => getRoundedMoneyValue(p, 'type2tax')[1],
                style: { fontSize: '40px', color: '#FFE100' }
            },

            {
                name: 'имеет ОКС, не имеет под собой ЗУ',
                field: "type3count",
                unit: "шт",
                style: { fontSize: '40px', color: '#63CC22' }
            },
            {
                name: 'дополнительный налог',
                field: (p) => getRoundedMoneyValue(p, 'type3tax')[0],
                unit: (p) => getRoundedMoneyValue(p, 'type3tax')[1],
                style: { fontSize: '40px', color: '#63CC22' }
            },

            {
                name: 'имеет ЗУ, не имеет ОКС',
                field: "type6count",
                unit: "шт",
                style: { fontSize: '40px', color: '#FF6A00' }
            },
            {
                name: 'дополнительный налог',
                field: (p) => getRoundedMoneyValue(p, 'type6tax')[0],
                unit: (p) => getRoundedMoneyValue(p, 'type6tax')[1],
                style: { fontSize: '40px', color: '#FF6A00' }
            },

            {
                name: 'имеет ЗУ, но по площади фундамента не может уместиться на них, либо геометрически сильно выходит за границы ЗУ',
                field: "type4count",
                unit: "шт",
                style: { fontSize: '40px', color: '#FFA077' }
            },
            {
                name: 'дополнительный налог',
                field: (p) => getRoundedMoneyValue(p, 'type4tax')[0],
                unit: (p) => getRoundedMoneyValue(p, 'type4tax')[1],
                style: { fontSize: '40px', color: '#FFA077' }
            },

            {
                name: 'ОКС с помещениями не на кадастре',
                field: "type5count",
                unit: "шт",
                style: { fontSize: '40px', color: '#20AFCC' }
            },
            {
                name: 'дополнительный налог',
                field: (p) => getRoundedMoneyValue(p, 'type5tax')[0],
                unit: (p) => getRoundedMoneyValue(p, 'type5tax')[1],
                style: { fontSize: '40px', color: '#20AFCC' }
            },






            {
                name: 'Тип нарушений',
                field: (p) => {
                    if (p.violations) {
                        let violations = JSON.parse(p.violations);
                        let text = '';
                        violations.forEach(t => {
                            if (t === '1 тип') {
                                text += 'Тип 1. не учтен в ЕГРН ни как ОКС, ни как совокупность помещений, не связан с ЗУ' + '<br/>';
                            }
                            if (t === '2 тип') {
                                text += 'Тип 2. учтен в ЕГРН как ОКС с неправдоподобно низкой площадью' + '<br/>';
                            }
                            if (t === '2 тип (без координат)') {
                                text += 'Тип 2. учтен в ЕГРН как ОКС с неправдоподобно низкой площадью' + '<br/>';
                            }
                            if (t === '3 тип') {
                                text += 'Тип 3. имеет ОКС, не имеет под собой ЗУ' + '<br/>';
                            }
                            if (t === '4 тип') {
                                text += 'Тип 4. имеет ЗУ, но по площади фундамента не может уместиться на них, либо геометрически сильно выходит за границы ЗУ' + '<br/>';
                            }
                            if (t === '6 тип') {
                                text += 'Тип 6. имеет ЗУ, не имеет ОКС' + '<br/>';
                            }
                        })
                        return text;
                    }
                },
                style: {
                    fontSize: "16px",
                    whiteSpace: "break-spaces",
                    maxWidth: "100%"
                }
            },

            { name: 'Адрес', field: (p) => p.address, style: { fontSize: "16px", whiteSpace: "break-spaces", maxWidth: "100%" } },
            { name: 'Тип строения', field: (p) => p.building_type, style: { fontSize: "22px", whiteSpace: "break-spaces", maxWidth: "100%" } },
            {
                name: 'Подтверждений по источникам',
                field: (p) => {
                    if (p.sources) {
                        return Object.keys(JSON.parse(p.sources)).length;
                    }
                },
                unit: "шт."
            },

            {
                name: 'Оценка стоимости',
                field: (p) => getRoundedMoneyValue(p, 'oks_cost_estimate')[0],
                unit: (p) => getRoundedMoneyValue(p, 'oks_cost_estimate')[1]
            },
            {
                name: 'Оценочный налога',
                field: (p) => getRoundedMoneyValue(p, 'oks_tax_estimate')[0],
                unit: (p) => getRoundedMoneyValue(p, 'oks_tax_estimate')[1]
            },
            { name: 'Фактическая площадь', field: "full_area", round: 3, unit: "м²" },
            { name: 'Площадь ОКС', field: "oks_area", round: 3, unit: "м²" },
            { name: 'Площадь фундамента', field: "basement_area", unit: "м²" },

            { name: 'Кадастровые номера ЗУ', field: (p) => { if (p.lands_cn) return JSON.parse(p.lands_cn).join('<br/>') }, style: { fontSize: '30px' } },
            { name: 'Кадастровые номера ОКС', field: (p) => { if (p.oks_cn) return JSON.parse(p.oks_cn).join('<br/>') }, style: { fontSize: '30px' } },


            {
                name: 'Резерв жилых квартир',
                field: (p) => {
                    if (p.estimatedExtra) {
                        let extra = JSON.parse(p.estimatedExtra);
                        return extra.livingRooms || '';
                    }
                },
                unit: "шт.",
                style: { fontSize: '30px' }
            },
            {
                name: 'общей площадью',
                field: (p) => {
                    if (p.estimatedExtra) {
                        let extra = JSON.parse(p.estimatedExtra);
                        return extra.livingSquare?.toFixed(1) || '';
                    }
                },
                unit: "м²",
                style: { fontSize: '30px' }
            },
            {
                name: 'дополнительный налог',
                field: (p) => {
                    if (p.estimatedExtra) {
                        let extra = JSON.parse(p.estimatedExtra);
                        return  getRoundedMoneyValue(extra, 'livingTax')[0];
                    }
                },
                unit: (p) => {
                    if (p.estimatedExtra) {
                        let extra = JSON.parse(p.estimatedExtra);
                        return  getRoundedMoneyValue(extra, 'livingTax')[1];
                    }
                },
                style: { fontSize: '30px' }
            },

         
            {
                name: 'Резерв нежилых помещений',
                field: (p) => {
                    if (p.estimatedExtra) {
                        let extra = JSON.parse(p.estimatedExtra);
                        return extra.unlivingRooms || '';
                    }
                },
                unit: "шт.",
                style: { fontSize: '30px' }
            },
            {
                name: 'общей площадью',
                field: (p) => {
                    if (p.estimatedExtra) {
                        let extra = JSON.parse(p.estimatedExtra);
                        return extra.unlivingSquare?.toFixed(1) || '';
                    }
                },
                unit: "м²",
                style: { fontSize: '30px' }
            },
            {
                name: 'дополнительный налог',
                field: (p) => {
                    if (p.estimatedExtra) {
                        let extra = JSON.parse(p.estimatedExtra);
                        return  getRoundedMoneyValue(extra, 'unlivingTax')[0];
                    }
                },
                unit: (p) => {
                    if (p.estimatedExtra) {
                        let extra = JSON.parse(p.estimatedExtra);
                        return  getRoundedMoneyValue(extra, 'unlivingTax')[1];
                    }
                },
                style: { fontSize: '30px' }
            }

        ],
        territoryNameFunc: (properties) => {
            return properties.ID ? properties.ID :
                (properties.level === 2) ? (properties.region + ', ' || '') + (properties.municipalitet || '') :
                    (properties.level === 3) ? (properties.region + ', ' || '') + (properties.municipalitet + ', ' || '') + (properties.settlement || '') :
                        (properties.region || '');
        },
        headerFunc: (properties) => {
            return properties.ID ? properties.ID :
                (properties.level === 2) ? properties.municipalitet :
                    (properties.level === 3) ? properties.settlement : properties.region;
        },
        subHeaderFunc: (properties) => {
            return properties.Address ? properties.Address :
                (properties.level === 2) ? properties.region :
                    (properties.level === 3) ? properties.municipalitet + ', ' + properties.region : '';;
        }
    },
    featureId: (feature) => {
        return Hash.SHA1((feature.properties_.ID || '') + (feature.properties_.id || '') + (feature.properties_.region || '') + (feature.properties_.level || '') + (feature.properties_.municipalitet || '') + (feature.properties_.settlement || ''));
    }
}


